import {APIService} from "../../common/APIService";
import {QuantityType} from "../../dto/QuantityType";

export class QuantityTypeService extends APIService {
  public async browse() {
    const json = await this.getJson<{data: {name: string, gradient: number|null, intercept: number|null}[]}>('quantities/types')
    return json.data.map(QuantityType.fromJson)
  }
}